var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostGroupMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M336 16c-85.312 0-176 28.032-176 80v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-16.672C225.952 164.736 282.016 176 336 176s110.048-11.264 144-32.672V160c0 15.648-39.36 40.608-113.344 46.784-8.768.704-15.328 8.48-14.592 17.28.672 8.352 7.68 14.656 15.904 14.656.48 0 .896-.032 1.376-.064 41.664-3.488 83.168-14.272 110.656-31.776V224c0 13.664-28.992 33.312-82.784 42.816-8.672 1.536-14.496 9.856-12.96 18.528 1.376 7.744 8.128 13.216 15.712 13.216.928 0 1.888-.064 2.816-.256 32.544-5.728 58.592-15.104 77.216-27.008V288c0 13.664-28.992 33.312-82.784 42.816-8.672 1.536-14.496 9.856-12.96 18.528 1.376 7.744 8.128 13.216 15.712 13.216.928 0 1.888-.064 2.816-.256 32.544-5.728 58.592-15.136 77.216-27.008V352c0 13.664-28.992 33.312-82.784 42.816-8.672 1.536-14.496 9.856-12.96 18.528 1.376 7.744 8.128 13.216 15.712 13.216.928 0 1.888-.064 2.816-.256 32.544-5.728 58.592-15.136 77.216-27.008V416c0 15.648-39.36 40.608-113.344 46.784-8.768.704-15.328 8.48-14.592 17.28.672 8.352 7.68 14.656 15.904 14.656.48 0 .896-.032 1.376-.064C440.352 488.704 512 462.112 512 416V96c0-51.968-90.688-80-176-80zm0 128c-87.904 0-144-28.448-144-48s56.096-48 144-48 144 28.448 144 48-56.096 48-144 48z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 208C90.688 208 0 236.032 0 288v128c0 51.968 90.688 80 176 80s176-28.032 176-80V288c0-51.968-90.688-80-176-80zm144 208c0 19.552-56.096 48-144 48S32 435.552 32 416v-16.672C65.952 420.736 122.016 432 176 432s110.048-11.264 144-32.672V416zm0-64c0 19.552-56.096 48-144 48S32 371.552 32 352v-16.672C65.952 356.736 122.016 368 176 368s110.048-11.264 144-32.672V352zm-144-16c-87.904 0-144-28.448-144-48s56.096-48 144-48 144 28.448 144 48-56.096 48-144 48z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostGroupMaster);
export default __webpack_public_path__ + "static/media/cost-group-master.e439d2345610f69c14f44725fb2ca0d9.svg";
export { ForwardRef as ReactComponent };